<template>
  <div>
    <!-- Presenter modal data -->
    <v-dialog v-model="presentermodal" width="900">
      <template v-slot:activator="{ on, attrs }">
        <div v-if="showDescription" class="d-flex" v-bind="attrs" v-on="on">
          <RaMediaDisplay
            v-if="presenter.attachments"
            location="primary"
            :media="presenterMedia"
            :sizes="sizes"
            class="eventdetails__schedule-presenters--profile"
          />
          <v-img
            v-else
            height="20px"
            width="20px"
            color="blue darken-2"
            class="media-display__profile-icon eventdetails__schedule-presenters--no-profile"
            src="https://reattendance-video-public.s3.eu-west-2.amazonaws.com/Icons/profile-icon.svg"
          />
          <div class="accordion__list">
            <p class="accordion__list-title">
              {{ presenter.name }}
            </p>
            <p class="accordion__list-desc" v-html="presenter.biography" />
          </div>
        </div>
        <div
          v-else
          class="eventdetails__schedule-presenters d-flex align-center"
          v-bind="attrs"
          v-on="on"
        >
          <RaMediaDisplay
            v-if="presenter.attachments"
            location="primary"
            :media="presenterMedia"
            :sizes="sizes"
            class="eventdetails__schedule-presenters--profile"
          />
          <v-img
            v-else
            height="20px"
            width="20px"
            color="blue darken-2"
            class="media-display__profile-icon eventdetails__schedule-presenters--no-profile"
            src="https://reattendance-video-public.s3.eu-west-2.amazonaws.com/Icons/profile-icon.svg"
          />
          <p class="eventdetails__schedule-presenters--name lobby__bg-text">
            {{ presenter.name }}
          </p>
        </div>
      </template>
      <v-card class="event-modal__wrap ra">
        <div
          class="ra__form-heading eventdetails__schedule-presenters--head lobby__bg"
        >
          <v-card-title class="ra__modal-title">
            <div class="d-flex">
              <RaMediaDisplay
                v-if="presenter.attachments"
                location="primary"
                :media="presenterMedia"
                :sizes="sizes"
                class="eventdetails__schedule-presenters--img"
              />
              <v-img
                v-else
                height="50px"
                width="50px"
                color="blue darken-2"
                class="media-display__profile-icon eventdetails__schedule-presenters--no-profile"
                src="https://reattendance-video-public.s3.eu-west-2.amazonaws.com/Icons/profile-icon.svg"
              />
              <h3
                class="eventdetails__schedule-presenters--title lobby__bg-text"
              >
                {{ presenter.name }}
              </h3>
            </div>
          </v-card-title>
          <ra-modal-close-button light @close-modal="close" />
        </div>
        <v-card-text class="eventdetails__schedule-modal lobby__bg">
          <!-- <p v-html="presenter.biography" class="eventdetails__schedule-presenters--desc"></p> -->
          <p
            class="eventdetails__schedule-presenters--desc lobby__bg-text"
            v-html="presenter.biography"
          ></p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RaMediaDisplay from "~/components/media/RaMediaDisplay";
import RaModalCloseButton from "~/components/general/RaModalCloseButton";
import mediaHandler from "~/plugins/media/mediaHandler";
export default {
  name: "RaSessionPresenter",
  components: { RaMediaDisplay, RaModalCloseButton },
  props: {
    presenter: Object,
    showDescription: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sizes: "(max-width:375px) 100vw, 100vw",
      menu: false,
      presentermodal: false
    };
  },
  computed: {
    presenterMedia() {
      return mediaHandler.getAllMediaForModel(
        "User",
        this.presenter.attachments || this.presenter.users.attachments
      );
    }
  },
  methods: {
    close() {
      this.presentermodal = false;
    }
  }
};
</script>

<style scoped>
.eventdetails__schedule-presenters--no-profile {
  font-size: 44px !important;
}
.eventdetails__schedule-presenters--no-img {
  font-size: 120px !important;
}
@media screen and (max-width: 959px) {
  .eventdetails__schedule-presenters--no-img {
    font-size: 80px !important;
  }
}
</style>
